import { getUserSubscriptions } from './admin/get-user-subscriptions';

export const subscriptionsSDK = {
    admin: {
        getUserSubscriptions,
    },
};
